import { render, staticRenderFns } from "./TableType5.vue?vue&type=template&id=3b377211&scoped=true&"
import script from "./TableType5.vue?vue&type=script&lang=js&"
export * from "./TableType5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b377211",
  null
  
)

export default component.exports